<template>
  <div class="h-screen flex flex-col">
    <div class="">
      <NavbarPage />
    </div>
    <div class="basis-full">
      <div class="mx-auto">
        <router-view />
        
        <button
          @click="openModal"
          class="fixed bottom-6 right-6 z-[9999] bg-blue-600 hover:bg-blue-700 w-16 h-16 rounded-full flex items-center justify-center shadow-2xl transition-all duration-300 animate-bounce">
          <svg xmlns="http://www.w3.org/2000/svg"
              class="w-8 h-8 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
            <path stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11
                    a6.002 6.002 0 00-4-5.659V5
                    a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159
                    c0 .538-.214 1.055-.595 1.436L4 17h5
                    m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
          </svg>
        </button>
        <div v-if="isOpen"
             class="fixed inset-0 bg-black/60 backdrop-blur-sm
                    flex items-center justify-center z-[99999]">

          <div
            class="bg-white dark:bg-gray-800 w-mainWidth rounded-xl p-6 relative shadow-2xl
                   transform transition-all duration-300 scale-100">
            <button
              @click="closeModal"
              class="absolute top-3 right-3 text-gray-500 hover:text-red-500 text-xl font-bold">
              ✕
            </button>

            <h2 class="text-xl font-bold mb-4 dark:text-white"></h2>

            <p class="italic text-lg dark:text-gray-300"><span class="font-bold ml-6">{{ $t("api.a") }}</span> {{ $t("api.text-a") }}</p>
            <p class="italic text-lg dark:text-gray-300 mt-4"><span class="font-bold ml-6">{{ $t("api.b") }}</span> {{ $t("api.text-b") }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="basis-footer">
      <FooterPage />
    </div>
  </div>
</template>

<script>
import NavbarPage from "@/views/NavbarPage";
import FooterPage from "@/views/FooterPage";
import { ref } from "vue";

export default {
  components: {
    NavbarPage,
    FooterPage,
  },

  setup() {
    const isOpen = ref(false);

    const openModal = () => {
      isOpen.value = true;
      document.body.style.overflow = "hidden";
    };

    const closeModal = () => {
      isOpen.value = false;
      document.body.style.overflow = "auto";
    };

    return {
      isOpen,
      openModal,
      closeModal,
    };
  },
};
</script>

<style>
* {
  font-family: Gilroy;
}

@font-face {
  font-family: "Gilroy Light";
  src: local("Gilroy-Light"), url(./fonts/Gilroy-Light.ttf) format("truetype");
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: "Gilroy";
  src: local("Gilroy-Regular"),
    url(./fonts/Gilroy-Regular.ttf) format("truetype");
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: "Gilroy Medium";
  src: local("Gilroy-Medium"),
    url(./fonts/Gilroy-Medium.ttf) format("truetype");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Gilroy Semi Bold";
  src: local("Gilroy-Semi-Bold"), url(./fonts/Gilroy-Semibold.ttf) format("truetype");
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: "Gilroy";
  src: local("Gilroy-Bold"),
    url(./fonts/Gilroy-Bold.ttf) format("truetype");
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: "Gilroy Black";
  src: local("Gilroy-Black"),
    url(./fonts/Gilroy-Black.ttf) format("truetype");
  font-weight: 900;
  font-style: normal;
}

.dark {
  background-color: #464646;
}
</style>
